import axios from "src/lib/axios";

// admin list
export const getAdminList = async ({
  keyword = null,
  page = null,
  page_size = null,
  order_case = "desc",
}) => {
  const { data: response } = await axios.get(`/admin/members`, {
    params: {
      keyword: keyword,
      page: page,
      page_size: page_size,
      order_case: order_case,
    },
  });
  return response.data;
};

export const getAllAdminRole = async () => {
  const { data: response } = await axios.get(`/admin/roles`);
  return response.data;
};

export const getAdminDetail = async (userId) => {
  const { data: response } = await axios.get(`/admin/profile/${userId}`);
  return response.data;
};

export const updateAdminDetail = async (userId, data) => {
  const { data: response } = await axios.patch(
    `/admin/profile/${userId}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

export const removeAdmin = async (userId) => {
  const { data: response } = await axios.patch(
    `/admin/remove/${userId}`,
  );
  return response.data;
};
